import { EventEmitter } from "events";
import { DynamicButtonConfiguration } from "../types";
import DynamicButtonService from "../services/DynamicButtonService";
import StoreContainer from "./StoreContainer";

interface DynamicButtonOptions {
  el: HTMLElement;
}

class DynamicButtonStore {
  private _emitter = new EventEmitter();
  private _options: DynamicButtonOptions;
  private _config: DynamicButtonConfiguration;

  async load() {
    this._config = await DynamicButtonService.fetch(
      StoreContainer.SettingStore.getSiteId(),
      StoreContainer.GroupStore.getPageGroupId()
    );

    this._emitter.emit("loaded");
  }

  getConfig() {
    return this._config;
  }

  mountPopoutButton(opts: DynamicButtonOptions) {
    console.warn(
      "mountPopoutButton is deprecated and will be removed in a future release. " +
        "Please use mountDynamicButton instead."
    );

    this.mountDynamicButton(opts);
  }

  mountDynamicButton(opts: DynamicButtonOptions) {
    this._options = opts;
    this._emitter.emit("mounted");
  }

  onMounted(callback: () => void) {
    this._emitter.addListener("mounted", callback);
  }

  onConfigLoaded(callback: () => void) {
    this._emitter.addListener("loaded", callback);
  }

  getContainer() {
    if (!this._options) {
      return null;
    }

    return this._options.el;
  }
}

export default DynamicButtonStore;
